export default __webpack_public_path__ + "locales/it/EmptyTrashDialog.json?hash=d2933cd61e173c92153af3b97ba8d6cc";